module.exports = __webpack_public_path__ + "img/hand.3ed9cb9c.png";